.react-datepicker-wrapper {
  display: inline-block;
  width: auto;
}

.react-datepicker {
  overflow: visible;
  border: none;
  box-shadow: var(--chakra-shadows-md);
}

.react-datepicker__header {
  background: none;
  border-bottom: none;
}

.react-datepicker__year-option:first-child,
.react-datepicker__year-option:last-child {
  padding-top: 5px;
  padding-bottom: 5px;
}

.react-datepicker__navigation.react-datepicker__navigation--years-upcoming,
.react-datepicker__navigation.react-datepicker__navigation--years-previous {
  width: 5px;
  height: 5px;
  border-style: solid;
  border-width: 1px 1px 0 0;
  top: 1px;
  border-color: var(--chakra-colors-black);
}

.react-datepicker__month-wrapper {
  display: flex;
  flex-direction: row;
}

.react-datepicker__navigation--years-upcoming {
  transform: rotateZ(-45deg);
}

.react-datepicker__navigation--years-previous {
  transform: rotateZ(135deg);
}

.react-datepicker__header__dropdown {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
  border-width: 1px 1px 0 0;
  border-color: var(--chakra-colors-black);
  width: 5px;
  height: 5px;
}

.react-datepicker__navigation-icon {
  top: 8px;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  top: 7px;
}

.react-datepicker__day,
.react-datepicker__day:hover {
  border-radius: var(--chakra-radii-full);
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--keyboard-selected {
  background: var(--chakra-colors-purple-500);
  color: var(--chakra-colors-white);
}

.react-datepicker__day--in-range,
.react-datepicker__month--in-range,
.react-datepicker__year--in-range {
  background: var(--chakra-colors-purple-300);
}

.react-datepicker__day--range-start,
.react-datepicker__day--range-end,
.react-datepicker__month--range-start,
.react-datepicker__month--range-end,
.react-datepicker__year--range-start,
.react-datepicker__year--range-end {
  background: var(--chakra-colors-purple-500);
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__year-text:hover {
  color: var(--chakra-colors-white);
  background: var(--chakra-colors-purple-500);
}

.react-datepicker__year-wrapper {
  justify-content: space-around;
}

/* Dropdowns */

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background: var(--chakra-colors-white);
  border: none;
  box-shadow: var(--chakra-shadows-md);
}

.react-datepicker__day-option--selected_month,
.react-datepicker__month-option--selected_month,
.react-datepicker__year-option--selected_month {
  color: var(--chakra-colors-white);
  background: var(--chakra-colors-purple-500);
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  display: none;
}

/* Clear button */

.react-datepicker__clear-button {
  height: 95%;
}

.react-datepicker__clear-button::after {
  color: var(--chakra-colors-gray-600);
  background: none;
  font-size: 1.3rem;
}
